import React, { useState, useRef, useEffect } from 'react';

function Navigation() {
    const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
    const [servicesDropdownOpen, setServicesDropdownOpen] = useState(false);
    const [mobileServicesOpen, setMobileServicesOpen] = useState(false);
    const dropdownRef = useRef(null);

    const handleScroll = (e, targetId) => {
        e.preventDefault();
        const element = document.getElementById(targetId);
        if (element) {
            element.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
        setMobileMenuOpen(false);
        setServicesDropdownOpen(false);
        setMobileServicesOpen(false);
    };

    // Close dropdown when clicking outside
    useEffect(() => {
        if (!servicesDropdownOpen) return;

        const handleClickOutside = (event) => {
            // Check if click is outside the dropdown wrapper
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setServicesDropdownOpen(false);
            }
        };

        // Use a longer delay to ensure button click completes
        const timeoutId = setTimeout(() => {
            window.addEventListener('click', handleClickOutside);
        }, 300);
        
        return () => {
            clearTimeout(timeoutId);
            window.removeEventListener('click', handleClickOutside);
        };
    }, [servicesDropdownOpen]);

    const services = [
        { name: 'Customer Care', link: 'customer-care.html' },
        { name: 'OTA Management', link: 'ota-management.html' },
        { name: 'Social Media', link: 'social-media.html' },
        { name: 'Email Marketing', link: 'email-marketing.html' },
        { name: 'App Development', link: 'software-development.html' },
        { name: 'Recruiting', link: 'recruiting.html' }
    ];

    return (
        <nav className="nav">
            <div className="nav-container">
                <div className="nav-logo">
                    <div className="nav-logo-icon">🏨</div>
                    <div className="nav-logo-text">Warp Mill</div>
                </div>

                <div className="nav-menu">
                    <div className="nav-services-wrapper" ref={dropdownRef}>
                        <button 
                            type="button"
                            className={`nav-link nav-services-toggle ${servicesDropdownOpen ? 'active' : ''}`}
                            onClick={(e) => {
                                e.preventDefault();
                                e.stopPropagation();
                                e.nativeEvent.stopImmediatePropagation();
                                setServicesDropdownOpen(prev => !prev);
                            }}
                            onMouseEnter={() => {
                                // Only open on hover if not already open
                                if (!servicesDropdownOpen) {
                                    setServicesDropdownOpen(true);
                                }
                            }}
                        >
                            Services
                            <span className="dropdown-arrow">▼</span>
                        </button>
                        {servicesDropdownOpen && (
                            <div 
                                className="services-dropdown"
                                onMouseEnter={() => setServicesDropdownOpen(true)}
                                onMouseLeave={() => setServicesDropdownOpen(false)}
                                onClick={(e) => e.stopPropagation()}
                            >
                                {services.map((service, index) => (
                                    <a 
                                        key={index}
                                        href={service.link} 
                                        className="services-dropdown-item"
                                        onClick={() => setServicesDropdownOpen(false)}
                                    >
                                        {service.name}
                                    </a>
                                ))}
                            </div>
                        )}
                    </div>
                    <a href="case-studies.html" className="nav-link">
                        Case Studies
                    </a>
                    <a href="#contact" className="nav-link" onClick={(e) => handleScroll(e, 'contact')}>
                        Contact
                    </a>
                    <a href="#contact" className="nav-cta" onClick={(e) => handleScroll(e, 'contact')}>
                        Get Free Audit
                    </a>
                </div>

                <button 
                    className="mobile-menu-btn"
                    onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
                    aria-label="Toggle menu"
                >
                    ☰
                </button>
            </div>

            <div className={`mobile-menu ${mobileMenuOpen ? 'active' : ''}`}>
                <div className="mobile-menu-links">
                    <div className="mobile-services-wrapper">
                        <button 
                            className={`nav-link mobile-services-toggle ${mobileServicesOpen ? 'active' : ''}`}
                            onClick={() => setMobileServicesOpen(!mobileServicesOpen)}
                        >
                            Services
                            <span className="dropdown-arrow">▼</span>
                        </button>
                        {mobileServicesOpen && (
                            <div className="mobile-services-dropdown">
                                {services.map((service, index) => (
                                    <a 
                                        key={index}
                                        href={service.link} 
                                        className="mobile-services-item"
                                        onClick={() => {
                                            setMobileServicesOpen(false);
                                            setMobileMenuOpen(false);
                                        }}
                                    >
                                        {service.name}
                                    </a>
                                ))}
                            </div>
                        )}
                    </div>
                    <a href="case-studies.html" className="nav-link" onClick={() => setMobileMenuOpen(false)}>
                        Case Studies
                    </a>
                    <a href="#contact" className="nav-link" onClick={(e) => handleScroll(e, 'contact')}>
                        Contact
                    </a>
                    <a href="#contact" className="nav-cta" onClick={(e) => handleScroll(e, 'contact')}>
                        Get Free Audit
                    </a>
                </div>
            </div>
        </nav>
    );
}

export default Navigation;

